import { Component, EventEmitter, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogItem, CatalogItemChanged } from 'src/app/domains/connectivity/models/connectivity.model';

@Component({
  selector: 'gdp-add-connectivity-entry',
  templateUrl: './add-connectivity-entry.component.html',
  styleUrls: ['./add-connectivity-entry.component.scss']
})
export class AddConnectivityEntryComponent implements OnInit {

  public currentFormValue: CatalogItemChanged;
  public onSubmit: EventEmitter<CatalogItem> = new EventEmitter();

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onValueChanges(changes: CatalogItemChanged) {
    this.currentFormValue = changes;
  }

  public submit() {
    this.onSubmit.emit(this.currentFormValue.value);
    this.close();
  }

  public close() {
    this.activeModal.close();
  }

}
